import { useRef, useState } from "react";
import styles from "./ContactsSalesNew.module.scss";
import cn from "classnames";
import TextField from "../../global/TextField/TextField";
import {
  FieldsTypes,
  InpitTypes,
} from "../../global/TextField/TextField.props";
import { ErrorMessage } from "@hookform/error-message";
import Button from "../../global/Button/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import * as Yup from "yup";
import { useDropzone } from "react-dropzone";
import ReCAPTCHA from "react-google-recaptcha";
import { REACT_RECAPTCH_KEY } from "../../../config";
import { toast } from "react-toastify";
import api from "../../../http/api";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import WithModal from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import { Contries } from "@components/global/Selector/Selector";

export interface ContactSalesI extends CheckboxesValuesI {
  name: string;
  email: string;
  number: string | number;
  many: string;
  machinesType: string;
  begin: string | Date;
  telegram?: string;
  message?: string;
  file?: File[];
}

interface ModalPropsI {
  handleClose: (open: boolean) => void;
  contactsModal?: boolean;
}
export interface CheckboxesValuesI {
  mobile?: boolean;
  whatsapp?: boolean;
  place?: boolean;
  inquiry?: boolean;
}

function ContactsSalesNew() {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const recapRef = useRef<any>(null);
  const [recaptchaResponsed, setRecaptchaResponsed] = useState<string>();
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const [socials, setSocials] = useState<boolean>(false);
  const [val, setVal] = useState<Contries>({
    name: "Afghanistan",
    dial_code: "+93",
    code: "AF",
  });
  const [begin, setBegin] = useState<Date | string>();
  const [loading, setLoading] = useState<boolean>(false);
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Email is invalid")
      .required("This field is required"),
    telegram: Yup.string().notRequired(),
    name: Yup.string().required("This field is required"),
    // number: Yup.number().typeError("Enther the full number"),
    // many: Yup.string().required("This field is required"),
    // machinesType: Yup.string().required("This field is required"),
  });

  // useEffect(() => {
  //   document.addEventListener("keydown", cancel);
  //   return document.removeEventListener("keydown", () => null);
  // }, []);
  // const cancel = (e: KeyboardEvent) => {
  //   if (e.key === "Escape") handleClose(false);
  // };

  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm<ContactSalesI>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      email: "",
      name: "",
      number: "",
      telegram: "",
      many: "",
      machinesType: "",
      message: "",
    },
  });

  const onError = (type: string) => (
    <ErrorMessage
      render={({ message }) => (
        <div style={{ color: "red", margin: "5px 0" }}>{message}</div>
      )}
      errors={errors}
      name={type}
    />
  );
  const onSubmit = async (data: ContactSalesI) => {
    setLoading(true);
    // const Mode = checkboxesValue.place ? "miners" : "general";
    const contactsData = {
      name: data.name,
      email: data.email,
      phone: data.number,
      // Mobile: checkboxesValue.mobile,
      // WhatsApp: checkboxesValue.whatsapp,
      contact: data.telegram,
      mode: "general",
      also_1: data.many,
      also_2: data.machinesType,
      also_3: begin,
      also_4: data.message,
      file: acceptedFiles[0],
    };
    const res: any = await api.order(contactsData, recaptchaResponsed);
    if (res.Status === "error") {
      toast.error(res.Message);
      recapRef.current.reset();
      setRecaptchaResponsed("");
    } else {
      navigate("/success_contacts");
    }
  };
  const renderFileName = () => (
    <label>
      [File: <i>{acceptedFiles[0].name}</i> ]
    </label>
  );

  interface LabelledFieldProps {
    msgID: string;
    placeholderID: string;
    field: FieldsTypes;
    type?: InpitTypes;
    registerName: "name" | "email" | "number" | "telegram" | "message";
    needError?: boolean;
    className?: string;
  }

  const LabelledField = ({
    className = styles.field,
    ...props
  }: LabelledFieldProps) => (
    <div>
      <label className={styles.filed_name}>
        {formatMessage({ id: props.msgID })}{" "}
      </label>
      <TextField
        field={props.field}
        type={props.type}
        placeholder={formatMessage({ id: props.placeholderID })}
        validation
        validRegister={{ ...register(props.registerName) }}
        autoComplete='off'
        color='primary'
        className={className}
      />
      {!!props.needError && onError(props.registerName)}
    </div>
  );

  return (
    <div className={cn(styles.wrapper)}>
      <h3> {formatMessage({ id: "modal.header.title" })} </h3>
      <p> {formatMessage({ id: "modal.header.subtitle" })} </p>

      <form onSubmit={handleSubmit(onSubmit)}>
        <LabelledField
          msgID='modal.name'
          placeholderID='modal.name'
          field={FieldsTypes.input}
          type={InpitTypes.text}
          registerName='name'
          needError
        />
        <LabelledField
          msgID='modal.email'
          placeholderID='modal.email'
          field={FieldsTypes.input}
          type={InpitTypes.email}
          registerName='email'
          needError
        />
        <LabelledField
          msgID='modal.phone'
          placeholderID='modal.phone'
          field={FieldsTypes.input}
          type={InpitTypes.number}
          registerName='number'
          needError
        />
        <LabelledField
          msgID='modal.telegram'
          placeholderID='modal.telegram'
          field={FieldsTypes.input}
          type={InpitTypes.text}
          registerName='telegram'
        />
        <LabelledField
          msgID='modal.textarea'
          placeholderID='modal.textarea.placeholder'
          field={FieldsTypes.textarea}
          registerName='message'
          className={styles.textArea}
        />
        {REACT_RECAPTCH_KEY && (
          <div className={cn(styles.recaptcha)}>
            <ReCAPTCHA
              ref={recapRef}
              sitekey={REACT_RECAPTCH_KEY}
              onChange={(response) => {
                if (response) {
                  setRecaptchaResponsed(response);
                }
              }}
            />
          </div>
        )}

        {loading ? (
          <Button disabled className={styles.button} type='submit'>
            {formatMessage({ id: "modal.btn.loading" })}
          </Button>
        ) : (
          <Button
            disabled={!!recaptchaResponsed ? false : true}
            className={styles.button}
            type='submit'
          >
            {formatMessage({ id: "modal.btn" })}
          </Button>
        )}
      </form>
    </div>
  );
}
export default WithModal(MODALS_ENUM.CONTACT_US, ContactsSalesNew);
